var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg-icon',{staticClass:"animate-spin max-w-full",class:_vm.iconClass,attrs:{"name":"IconSpinner"}})}
var staticRenderFns = []

export { render, staticRenderFns }